var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvailabilityLimited = function SvgIconAvailabilityLimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(2.5 2.5)",
    fill: "#FE9739"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat, sans-serif",
    fontSize: 13.333,
    fontWeight: "bold",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.627,
    y: 13.833
  }, "\u20BA")))));
};
export default SvgIconAvailabilityLimited;